export const BANK_ACCOUNTS = {
  safa: {
    id: 'safa',
    nameAr: 'بنك الصفاء',
    nameFr: 'Bank Assafa',
    rib: '362780920123000110091973',
    swift: 'BCMAMAMC',
    theme: 'safa',
  },
  cdm: {
    id: 'cdm',
    nameAr: 'مصرف المغرب',
    nameFr: 'Crédit du Maroc',
    rib: '021780000023801505780181',
    swift: 'CDMAMAMC',
    theme: 'cdm',
  },
};

const SAFA_PROGRAMS = ['saqya', 'kafala'];
const CDM_PROGRAMS = ['omra', 'caravane', 'adahi', 'ihyaa', 'ramadan', 'imaar'];

const CATEGORY_TO_PROGRAM = [
  [['saqya', 'سقيا', 'سقيا عطاء'], 'saqya'],
  [['kafala', 'كفالة', 'أيتامنا'], 'kafala'],
  [['omra', 'omrah', 'umra', 'umrah', 'عمرة', 'ضيوف الرحمن'], 'omra'],
  [['caravane', 'قوافل تضامنية'], 'caravane'],
  [['adahi', 'ihyaa', 'إحياء', 'أضحية العيد'], 'adahi'],
  [['ramadan', 'imaar', 'مائدة الرحمن', 'إعمار'], 'ramadan'],
];

export const programSlugFromCategory = (category) => {
  const value = String(category || '').trim();
  if (!value) return '';
  const lower = value.toLowerCase();
  const found = CATEGORY_TO_PROGRAM.find(([keys]) => (
    keys.some((key) => key.toLowerCase() === lower)
  ));
  return found ? found[1] : '';
};

export const formatRib = (rib) => String(rib || '').replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim();

export const accountsForDonateContext = (programSlug) => {
  const slug = String(programSlug || '').trim().toLowerCase();
  if (!slug) return [BANK_ACCOUNTS.safa, BANK_ACCOUNTS.cdm];
  if (SAFA_PROGRAMS.includes(slug)) return [BANK_ACCOUNTS.safa];
  if (CDM_PROGRAMS.includes(slug)) return [BANK_ACCOUNTS.cdm];
  return [BANK_ACCOUNTS.safa, BANK_ACCOUNTS.cdm];
};
